export default __webpack_public_path__ + "static/media/OpenColor.88fa80ac.png";